const FeatureModule = {
  namespaced: true,
  state: {
    features: {}
  },
  actions: {
    importFeaturesFromCto ({ commit }) {
      const data = window.$feconfig?.features || []
      const actualDate = new Date()
      data.forEach(({ feature, value, startDate = '2000-01-01T00:00:00+00:00', endDate = '3000-01-01T00:00:00+00:00' }) => {
        if (actualDate < new Date(startDate) || actualDate > new Date(endDate)) {
          value = !value
        }
        commit('setFeature', { feature, value })
      })
    }
  },
  mutations: {
    setFeature: (state, { feature, value }) => {
      state.features[feature] = value
    }
  },
  getters: {
    isActive: (state, getters) => (featureName) => {
      // if feature is defined, return the corresponding value
      if (state.features[featureName] !== undefined) {
        return state.features[featureName]
      }
      // otherwise use the false for undefined features
      return false
    }
  }
}

export {
  FeatureModule
}
